/**
 * Leadership — shared data source.
 *
 * Consumed by:
 *  · pages/LeadershipPage.jsx (dedicated /leadership page · full bios)
 *  · pages/TeamPage.jsx (compact card grid on /team)
 *  · components/landing/Partnership.jsx (homepage block · Leadership tier)
 *
 * "Leadership" is the executive tier below Partners — senior operational
 * staff who lead a specific function (Capital Formation, Operations, etc.)
 * without partner economics.
 */
export const LEADERSHIP = [
  {
    id: "sophus-kludt",
    anchor: "sophus-kludt",
    initials: "SK",
    name: "Sophus Kludt",
    role: "Head of Capital Formation",
    subtitle:
      "Institutional Investors · Family Offices · Fund & SPV Capital-Raising",
    focus:
      "Institutional Investors · Family Offices · Fund & SPV Capital-Raising",
    short:
      "Sophus leads capital-raising initiatives for KR-sponsored funds and special-purpose vehicles — developing targeted capital-formation strategies and cultivating long-term institutional and family-office relationships.",
    bio: [
      "Sophus Kludt serves as Head of Capital Formation at Kellermann Reid & Co., where he leads capital-raising initiatives for KR-sponsored investment funds and special-purpose vehicles.",
      "He is responsible for developing and executing targeted capital-formation strategies, identifying and engaging institutional investors, family offices and other qualified capital partners, and managing investor relationships from initial engagement and qualification through due diligence and closing.",
      "In addition to his capital-formation responsibilities, Sophus contributes to the origination of select investment opportunities for consideration by KR's investment team and sponsored vehicles. Working closely with the firm's leadership and investment professionals, he helps align prospective opportunities and capital partners with the mandates, return objectives and strategic priorities of each fund or SPV.",
      "His approach is centred on selective, relationship-led engagement and the development of long-term capital partnerships across global markets.",
    ],
    pillars: [
      { label: "Function", value: "Capital Formation" },
      { label: "Coverage", value: "Institutional · Family Office" },
      { label: "Mandate", value: "Fund & SPV Raising" },
    ],
    email: "sophus.kludt@krprivatecapital.com",
    phone: "+45 44 18 73 26",
    linkedin: "https://www.linkedin.com/in/sophuskludt/",
    photo: "/portraits/sophus-kludt.jpg",
  },
];
